import { effect, Signal } from "@preact/signals";
import { Middleware } from "polymatic";

interface SignalMiddlewareOptions {
  debug?: string;
}

export class SignalMiddleware extends Middleware {
  private activateList: (() => void)[] = [];
  private deactivateList: (() => void)[] = [];

  constructor(private options: SignalMiddlewareOptions = {}) {
    super();
    this.on("activate", this.handleActivate);
    this.on("deactivate", this.handleDeactivate);
  }

  handleActivate = () => {
    const list = [...this.activateList];
    this.activateList = [];
    if (this.options.debug) {
      console.debug(this.options.debug, "handleActivate", list);
    }
    list.forEach((callback) => {
      try {
        callback();
      } catch (error) {
        console.error("Error activating signal effect:", error);
      }
    });
  };

  handleDeactivate = () => {
    const list = [...this.deactivateList];
    this.deactivateList = [];
    if (this.options.debug) {
      console.debug(this.options.debug, "handleDeactivate", list);
    }
    list.forEach((callback) => {
      try {
        callback();
      } catch (error) {
        console.error("Error disposing signal effect:", error);
      }
    });
  };

  effect = (...args: Parameters<typeof effect>) => {
    if (this.activated) {
      this.deactivateList.push(effect(...args));
    } else {
      this.activateList.push(() => {
        this.deactivateList.push(effect(...args));
      });
    }
    if (this.options.debug) {
      console.debug(this.options.debug, "effect", this.activated, this.deactivateList, args[0]);
    }
  };

  subscribe = <T>(signal: Signal<T>, callback: (value: T) => void) => {
    if (this.activated) {
      this.deactivateList.push(signal.subscribe(callback));
    } else {
      this.activateList.push(() => {
        this.deactivateList.push(signal.subscribe(callback));
      });
    }
    if (this.options.debug) {
      console.debug(this.options.debug, "subscribe", this.activated, this.deactivateList, callback);
    }
  };
}
